import { Box, Button } from "@mantine/core";

const AddFilterBtn = (props: {
  selectedParentFilter: string;
  childFiltersValue: { [key: string]: string[] };
  disabled?: boolean;
  onClick: () => void;
  BtnText: string;
  hidden?: boolean;
}) => {
  if (props.hidden) return null;

  return (
    <Box p={0} m={0} sx={{
      maxWidth:'-webkit-fill-available',
      "div":{
        maxWidth:'-webkit-fill-available',
      }
    }}>
      <Button
        fullWidth
        disabled={props.disabled}
        styles={(theme) => ({
          root: {
            backgroundColor: "#5B60E3",
            border: 0,
            height: 32,
            fontSize: 12,
            borderRadius: "4px",
            "&:hover": {
              backgroundColor: theme.fn.darken("#5B60E3", 0.05),
            },
            "&:disabled": {
              backgroundColor: "#E9ECEF",
              color: "#6C757D",
              cursor: "not-allowed",
            },
          },
          label:{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }
        })}
        
        onClick={props.onClick}
      >
        {props.BtnText}
      </Button> 
    </Box>
  );
};

export default AddFilterBtn;
